<template>
  <div>
    <div class="searchDiv">
      <el-input class="searchInput" v-model="params.orderNo" placeholder="请输入订单号" clearable @clear="getPageList"
                @keyup.enter.native="getPageList"/>
      <el-cascader
          v-model="stepIdPath"
          :options="stepOptions"
          :props="{ expandTrigger: 'hover', value: 'id', label: 'name', children: 'steps' }"
          :show-all-levels="false"
          placeholder="选择审批步骤"
          clearable
      ></el-cascader>
      <el-button type="primary" @click="getPageList">查询</el-button>
      <!--      <el-button v-if="hasPer('flow:add')" @click="editRow" style="float: right;">新增</el-button>-->
    </div>
    <el-table :data="tableData" row-key="id" border>
      <el-table-column label="客户姓名" prop="order.customerName" width="150px"></el-table-column>
      <el-table-column label="订单号" prop="orderNo" width="250px"></el-table-column>
      <el-table-column label="产品" prop="order.productName"></el-table-column>
      <el-table-column label="业务员" prop="order.salesmanName"></el-table-column>
      <el-table-column label="审批流程" prop="flowName"></el-table-column>
      <el-table-column label="审批步骤" prop="flowStep.name"></el-table-column>
      <el-table-column label="审批岗位" prop="flowStep.approvalPosName"></el-table-column>
      <el-table-column label="创建时间" prop="createTime"></el-table-column>
      <el-table-column label="操作" prop="option" width="220px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('audit:gain')" type="primary" @click="getTask(scope.row)">
            认领
          </el-button>
          <!--          <el-button v-if="hasPer('flow:del')" type="danger" @click="delRow(scope.row.id, scope.row.name)">删除-->
          <!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination :current.sync="current" :size.sync="size" :total="total" @get-list="getPageList"></pagination>
    <edit-flow :dialog-visible.sync="dialogVisible" :data-obj="rowDataObj" @get-list="getPageList"></edit-flow>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import store from "@/store";
import EditFlow from "@/views/approval/flow/editFlow.vue";
import {auditPage, getTask} from "@/api/sys/flow/audit";
import {getFlowTree} from "@/api/sys/flow/flow";

export default {
  name: "audit",
  components: {
    EditFlow,
    Pagination
  },
  data() {
    return {
      params: {
        orderNo: '',
        currentStep: null
      },
      stepIdPath: [],
      stepOptions: [],
      username: store.state.userInfo.username,
      tableData: [],
      dialogVisible: false,
      rowDataObj: {},
      current: 1,
      size: 10,
      total: 0
    }
  },
  watch: {
    'stepIdPath': {
      handler(val) {
        if (val.length === 2) {
          this.params.currentStep = val[1];
        }else{
          this.params.currentStep = null;
        }
      },
      immediate: true,
      deep: true // 确保监听数组变化
    }
  },
  mounted() {
    this.getPageList();
    getFlowTree().then(res => {
      this.stepOptions = res
    })
  },
  methods: {
    hasPer,
    getPageList() {
      auditPage({...this.params}).then(res => {
        this.tableData = res.records
        this.total = res.total
      })
    },
    editRow(row) {
      this.dialogVisible = true
      this.rowDataObj = row.id ? row : {}
    },
    getTask(row) {
      this.$confirm('确定认领订单【' + row.orderNo + '】的审批？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getTask({taskId: row.id}).then(() => {
          successMsg("操作成功")
          this.getPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    }
  }
}
</script>

<style scoped>

</style>
